import { BarChart } from '@mui/x-charts/BarChart'
import { Paper, CircularProgress, Box } from '@mui/material'
import { useGetPartnerVoucherChartQuery } from 'store/dashboard'
import ChartTitle from './ChartTitle'
import NoDataAvailable from './NoDataAvailable'
import { useTimeRange } from './TimeRangeContext'
import { barChartBottomLegendSlotProps, chartSx } from './chartDefaults'

const PartnerVoucherChart = () => {
  const { startDate, endDate } = useTimeRange()

  const { data, isLoading, isError, refetch, isFetching } = useGetPartnerVoucherChartQuery({
    startDate,
    endDate
  })

  return (
    <Paper
      sx={{
        p: 2,
        height: '100%',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        boxShadow: 'none'
      }}
      elevation={0}
    >
      <ChartTitle tooltip='Display the most claimed vouchers by partner'>
        Most Claim Voucher / Partner
      </ChartTitle>

      {isLoading || isFetching ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <CircularProgress />
        </Box>
      ) : isError ? (
        <NoDataAvailable variant='error' onRefresh={refetch} />
      ) : !data ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : data.data.length === 0 ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : (
        <>
          <Box sx={{ width: '100%', height: 300, mb: 3 }}>
            <BarChart
              xAxis={[
                {
                  data: data.data.map((d) => d.partnerName),
                  scaleType: 'band'
                }
              ]}
              yAxis={[{ tickMinStep: 1 }]}
              series={[
                {
                  label: 'Total Voucher',
                  data: data.data.map((d) => d.totalVoucher),
                  color: '#002C5F'
                },
                {
                  label: 'Claimed',
                  data: data.data.map((d) => d.totalRedeemed),
                  color: '#4A90D9'
                }
              ]}
              height={300}
              margin={{ top: 20, right: 30, left: 40, bottom: 120 }}
              slotProps={barChartBottomLegendSlotProps}
              sx={chartSx}
            />
          </Box>
        </>
      )}
    </Paper>
  )
}

export default PartnerVoucherChart
